import { Skeleton } from "@mantine/core";
import { useTotalCallCount } from "../hooks/useMetric";
import { MetricCard } from "./MetricCard";

export function TotalCallCountCard() {
    const { data: numCalls, isLoading, isError } = useTotalCallCount();

    if (isError) return <></>;
    if (isLoading) return <MetricCard header={<Skeleton h="xl" />} body={<Skeleton h="md" />} updatedTime="" />;

    return <MetricCard header={`${numCalls} calls`} body="Total calls" updatedTime="Live" />;
}
